module.exports = __webpack_public_path__ + "static/img/capability1.e306e6e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/capability1.png
// module id = Z1WT
// module chunks = 1